module.exports = __webpack_public_path__ + "static/img/read_icon.2810adc5.png";